var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('router-link',{staticClass:"button is-success",attrs:{"to":{'name':'client-content-links-create', params: { clientId: _vm.clientId }}}},[_vm._v("Create link")])],1)]),_vm._v(" "),_c('content-links-list',{attrs:{"items":_vm.items,"reload":_vm.reload}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/clients/client/content/links/list.vue?vue&type=template&id=39b99efa
// module id = 3RNB
// module chunks = 0